import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const BooksSmileIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 22 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M6.31912 12.5581C6.7087 12.5581 7.02496 12.2305 7.02496 11.8265C7.02496 11.4223 6.7087 11.0947 6.31912 11.0947C5.92954 11.0947 5.61328 11.4223 5.61328 11.8265C5.61328 12.2305 5.92954 12.5581 6.31912 12.5581Z'
        fill={color}
      />
      <path
        d='M12.7777 11.8265C12.7777 12.2305 12.4376 12.5581 12.0177 12.5581C11.5979 12.5581 11.2578 12.2305 11.2578 11.8265C11.2578 11.4223 11.5979 11.0947 12.0177 11.0947C12.4376 11.0947 12.7777 11.4223 12.7777 11.8265Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.02344 13.0882C7.02344 13.0433 7.05919 13.0078 7.10227 13.0078H11.0687C11.1127 13.0078 11.1475 13.0433 11.1475 13.0882C11.1475 14.2872 10.2244 15.2591 9.08594 15.2591C7.94652 15.2591 7.02344 14.2872 7.02344 13.0882ZM9.95401 14.6601C9.95401 14.6803 9.93753 14.6963 9.91828 14.6963H8.25269C8.23344 14.6963 8.21694 14.6803 8.21694 14.6601C8.21694 14.1206 8.6056 13.6832 9.08594 13.6832C9.56535 13.6832 9.95401 14.1206 9.95401 14.6601Z'
        fill={color}
      />
      <path
        d='M3.0657 19.5648C2.86953 19.5648 2.71094 19.4341 2.71094 19.2728V13.9189C2.71094 13.7577 2.86953 13.627 3.0657 13.627C3.26186 13.627 3.42136 13.7577 3.42136 13.9189V19.2728C3.42136 19.4341 3.26186 19.5648 3.0657 19.5648Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.61833 0C5.75483 0 4.97292 0.583293 4.97292 1.39449V2.23892H4.01408C3.14966 2.23892 2.36867 2.82221 2.36867 3.63351V4.47102H1.64542C0.788332 4.47102 0 5.05015 0 5.87197V22.0309V22.0397V22.0506C0 23.1354 0.903832 24 2.00108 24H17.0271V21.1869H19.3948V18.9479H22V0H6.61833ZM3.52734 4.47102H5.1975V3.27582H4.01408C3.70058 3.27582 3.52734 3.47704 3.52734 3.63351V4.47102ZM17.0271 4.47102V16.9697H18.2353V3.27582H5.90792V4.47102H17.0271ZM17.0271 17.9619V20.0327H18.2353V17.9619H17.0271ZM2.00108 22.858C1.58767 22.858 1.25491 22.5762 1.177 22.2134C1.166 22.1371 1.1605 22.0765 1.15958 22.0392C1.166 21.6066 1.53175 21.2432 2.00108 21.2432H15.8675V21.7359H2.91867C2.79401 21.7359 2.69408 21.8372 2.69408 21.9623C2.69408 22.0874 2.79401 22.1887 2.91867 22.1887H15.8675V22.858H2.00108ZM2.00108 20.1012C1.70133 20.1012 1.41625 20.1658 1.15958 20.2817V5.87197C1.15958 5.72409 1.32733 5.52083 1.64542 5.52083H2.71149V9.98511C2.71149 10.0031 2.71334 10.0207 2.717 10.0379C2.71334 10.055 2.71149 10.0726 2.71149 10.0906V12.3295C2.71149 12.4908 2.87008 12.6216 3.06625 12.6216C3.26242 12.6216 3.42192 12.4908 3.42192 12.3295V10.0906C3.42192 10.0726 3.42008 10.055 3.4155 10.0379C3.42008 10.0207 3.42192 10.0031 3.42192 9.98511V5.52083H15.8675V20.1012H2.00108ZM20.8404 15.7229V17.7938H19.3948V15.7229H20.8404ZM6.1325 2.23892V1.39449C6.1325 1.23812 6.30483 1.03689 6.61833 1.03689H7.56616V2.23892H6.1325ZM8.27659 2.23892V1.03689H20.8404V14.7307H19.3948V2.23892H8.27659Z'
        fill={color}
      />
    </svg>
  )
})

BooksSmileIcon.displayName = 'BooksSmileIcon'
